(() => {
  const STORAGE_KEY = 'sakehinata:favorites';
  const MAX_ITEMS = 50;

  const read = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.map(String).slice(0, MAX_ITEMS) : [];
    } catch (error) {
      return [];
    }
  };

  const write = (ids) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
      return true;
    } catch (error) {
      return false;
    }
  };

  const updateButton = (button, active) => {
    const label = active ? 'お気に入りから削除' : 'お気に入りに追加';
    button.classList.toggle('is-favorite', active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', label);
    const labelElement = button.querySelector('[data-favorite-label]');
    if (labelElement) labelElement.textContent = label;
  };

  const render = () => {
    const ids = read();
    const idSet = new Set(ids);

    document.querySelectorAll('[data-favorite-button][data-product-id]').forEach((button) => {
      updateButton(button, idSet.has(String(button.dataset.productId)));
    });

    document.querySelectorAll('[data-favorites-page]').forEach((page) => {
      let visibleCount = 0;
      page.querySelectorAll('[data-favorite-item]').forEach((item) => {
        const visible = idSet.has(String(item.dataset.favoriteItem));
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      const empty = page.querySelector('[data-favorites-empty]');
      if (empty) empty.hidden = ids.length !== 0;

      const unavailable = page.querySelector('[data-favorites-unavailable]');
      if (unavailable) unavailable.hidden = ids.length === visibleCount;

      const count = page.querySelector('[data-favorites-count]');
      if (count) count.textContent = String(ids.length);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-favorite-button][data-product-id]');
    if (!button) return;

    const id = String(button.dataset.productId);
    const ids = read();
    const index = ids.indexOf(id);

    if (index >= 0) {
      ids.splice(index, 1);
    } else {
      if (ids.length >= MAX_ITEMS) {
        window.alert(`お気に入りは${MAX_ITEMS}件まで登録できます。`);
        return;
      }
      ids.push(id);
    }

    if (!write(ids)) {
      window.alert('お気に入りを保存できませんでした。ブラウザの設定をご確認ください。');
      return;
    }

    render();
  });

  document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('pageshow', render);
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) render();
  });
})();
